import dynamic from 'next/dynamic';

import {
  WIDGET_TYPES as TYPES,
  WIDGET_TEMPLATES as TEMPLATES,
} from './constants';
import { WidgetPlugin } from './types';
import { WysiwygRendererProps } from '../Wysiwyg';

export const WysiwygTextBasic: WidgetPlugin<WysiwygRendererProps> = {
  type: TYPES.WYSIWYG_TEXT,
  template: TEMPLATES.BASIC,
  component: dynamic(() =>
    import('@/components/organisms').then(mod => mod.WysiwygRenderer),
  ),
  mapProps: widget => ({
    html: !Array.isArray(widget.template.parameters)
      ? widget.template.parameters?.content || ''
      : '',
  }),
};
